export default "__VITE_ASSET__PNmg3M41__"